import React from "react"

import { cn } from "@/lib/utils"
import CategoryCardSubcategoryListClient from "@/components/search-and-category/CategoryCardSubcategoriesListClient"
import type { CategoryCard } from "@/components/storyblok/UbCategoryResults"

export default function CategoryCardNew({
  showImage,
  showSubcategories,
  sbLocale,
  categoryCard,
}: {
  showImage?: boolean
  showSubcategories?: boolean
  sbLocale: string
  categoryCard: CategoryCard
}) {
  return (
    <div
      key={categoryCard.name}
      className={cn("group relative flex flex-col gap-2 overflow-hidden rounded-lg bg-white shadow-lg", {
        "transition duration-200 ease-in-out hover:z-150 hover:scale-105": showImage && !showSubcategories,
        "h-auto min-h-72 transition duration-200 ease-in-out hover:z-150 hover:scale-105":
          showImage && showSubcategories,
      })}
    >
      {showImage && (
        <>
          {categoryCard.img && categoryCard.img !== "" ? (
            <>
              <a
                className={cn("absolute inset-0 hidden", {
                  block: !(categoryCard.subCategories && categoryCard.subCategories.length > 0),
                })}
                href={categoryCard.link}
              />
              <a className={""} href={categoryCard.link}>
                {/* eslint-disable-next-line @next/next/no-img-element */}
                <img
                  alt={categoryCard.name}
                  className={cn("hidden h-48 w-full rounded-t-lg object-contain object-top p-2", { block: showImage })}
                  src={categoryCard.img}
                />
              </a>
            </>
          ) : (
            <div className={"w-full"}></div>
          )}
        </>
      )}
      <div className={cn("justify-left flex py-4 px-4 md:px-6")}>
        <a className={""} href={categoryCard.link}>
          <h2 className="text-left text-lg/tight font-bold group-hover:text-primary">{categoryCard.name}</h2>
        </a>
      </div>
      {showSubcategories && (
        <div className="px-4 pb-[1rem] md:px-6 md:pb-[1.5rem]">
          <CategoryCardSubcategoryListClient categoryCard={categoryCard} sbLocale={sbLocale} />
        </div>
      )}
    </div>
  )
}
